module.exports = __webpack_public_path__ + "img/frame-ja.ae14cee3.png";